import { EditorState } from "draft-js";
import { richTextContentFromHtml, richTextToHtml } from "../shared/utils/richTextHtml";

export const SUGGESTED_SECTION_HEADING = "What you'll learn";

let sectionSeq = 0;
const newSectionKey = () => `section-${(sectionSeq += 1)}`;

export const newSection = (suggestedHeading = "") => ({
  key: newSectionKey(),
  heading: "",
  suggestedHeading,
  editorState: EditorState.createEmpty(),
});

export const sectionsFromTemplate = (savedSections) =>
  (savedSections || []).map((section) => ({
    key: `existing-${section.id}`,
    id: section.id,
    heading: section.heading || "",
    suggestedHeading: "",
    editorState: EditorState.createWithContent(richTextContentFromHtml(section.body || "")),
  }));

export const suggestedSections = () => [newSection(SUGGESTED_SECTION_HEADING)];

export const sectionHasBody = (section) => section.editorState.getCurrentContent().getPlainText().trim() !== "";

export const sectionHeading = (section) => section.heading.trim() || section.suggestedHeading;

const isBlank = (section) => section.heading.trim() === "" && !sectionHasBody(section);

export const keptSections = (sections) => sections.filter((section) => !isBlank(section));

export const sectionsError = (sections) =>
  keptSections(sections).some((section) => sectionHeading(section) === "")
    ? "Every page section with text needs a heading."
    : null;

export const sectionsAttributes = (sections, savedSections) => {
  const kept = keptSections(sections);
  const attributes = kept.map((section, index) => {
    const attr = {
      heading: sectionHeading(section),
      body: sectionHasBody(section) ? richTextToHtml(section.editorState.getCurrentContent()) : "",
      position: index + 1,
    };
    if (section.id) attr.id = section.id;
    return attr;
  });

  const keptIds = new Set(kept.filter((section) => section.id).map((section) => section.id));
  (savedSections || []).forEach((section) => {
    if (!keptIds.has(section.id)) attributes.push({ id: section.id, _destroy: true });
  });

  return attributes;
};
